export default "__VITE_ASSET__Bj$laCkQ__"